import { z } from "zod";

import { auditEventImportingSchema } from "./audit-event-importing";
import { auditEventGeneralSchema } from "./audit-event-general";
import { auditEventStagedSchema } from "./audit-event-staged";
import { auditEventImportedSchema } from "./audit-event-imported";
import { auditEventFailedSchema } from "./audit-event-failed";
import { auditEventSelectedSchema } from "./audit-event-selected";
import { auditEventProducedSchema } from "./audit-event-produced";
import { auditEventImportFailedSchema } from "./audit-event-import-failed";
import { auditEventImportIgnoredSchema } from "./audit-event-import-ignored";
import { auditEventRetractedSchema } from "./audit-event-retracted";
import { auditEventClosingSchema } from "./audit-event-closing";

export const auditEventSchema = z.union([
	auditEventClosingSchema,
	auditEventFailedSchema,
	auditEventImportIgnoredSchema,
	auditEventGeneralSchema,
	auditEventImportFailedSchema,
	auditEventImportedSchema,
	auditEventImportingSchema,
	auditEventProducedSchema,
	auditEventSelectedSchema,
	auditEventStagedSchema,
	auditEventRetractedSchema,
]);

export type AuditEvent = z.infer<typeof auditEventSchema>;
